// ============================================================
// CALL HANDLER DATA — Edit prices and content here
// ============================================================

// Aquacremation base pricing
export const AQUA_PRICING = {
  Dogs: [
    { weight: '1 – 19 kg', price: 450 },
    { weight: '20 – 39 kg', price: 500 },
    { weight: '40 – 49 kg', price: 550 },
    { weight: '50 – 59 kg', price: 600 },
    { weight: '60 – 69 kg', price: 700 },
    { weight: '70 – 79 kg', price: 800 },
    { weight: '80 kg or over', price: 1000 },
  ],
  Cats: [{ weight: 'Any weight', price: 400 }],
  'Exotic pets': [
    { weight: 'Up to 500 g', price: 250 },
    { weight: 'Up to 1.9 kg', price: 280 },
  ],
};

// Collection fees
export const COLLECTION_FEE_BH = 120; // business hours
export const COLLECTION_FEE_AH = 185; // after hours
export const HOME_DELIVERY_FEE = 40;

// Regional transport
export const REGIONAL_TRANSPORT = [
  { town: 'Ayr', fee: 190, clinics: ['Tropical Vets', 'Burdekin Veterinary Services'], courier: 'Town Island Couriers — Caz · townislandcouriers@gmail.com', returnMethod: 'via Express Post (signature required) to the client\'s home' },
  { town: 'Bowen', fee: 195, clinics: ['Brolgas Rest Vet Clinic', 'Greater Whitsunday Vet Services'], courier: 'Heavenly Departures — Amanda Brown · mandybrownsemail@gmail.com', returnMethod: 'to the vet clinic or the client\'s home' },
  { town: 'Charters Towers', fee: 240, clinics: ['Charters Towers Veterinary Services', 'Gold City Veterinary Clinic'], courier: 'Town Island Couriers — Caz · townislandcouriers@gmail.com', returnMethod: 'via Express Post (signature required) to the client\'s home' },
  { town: 'Ingham', fee: 190, clinics: ['Tropical Vets Ingham'], courier: 'Town Island Couriers — Caz · townislandcouriers@gmail.com', returnMethod: 'via Express Post (signature required) to the client\'s home' },
];

// Euthanasia fees (Angel Area)
export const EUTHANASIA_FEES = [
  { weight: 'Under 19 kg', fee: 420 },
  { weight: '20 – 49 kg', fee: 480 },
  { weight: '50 kg and over', fee: 550 },
];

// Viewing fees
export const VIEWING_FEES = [
  { duration: '30 minutes', fee: 150 },
  { duration: '45 minutes', fee: 180 },
];

// Inclusions (standard with every aquacremation)
export const STANDARD_INCLUSIONS = [
  'Guaranteed individual aquacremation',
  'Scattering pouch',
  'Paw candle',
  'Tree planting living tribute',
  'Digital certificates',
];

// Euthanasia inclusions
export const EUTHANASIA_INCLUSIONS = [
  '1 hour exclusive access to The Angel Area',
  'Licensed veterinarian',
  'Gentle sedation + final injection',
  'Angel wing photo backdrop',
  'Comfort items',
  'Keepsake token',
];

// Viewing inclusions
export const VIEWING_INCLUSIONS = [
  'Exclusive access to The Angel Area',
  'Raised bed setup',
  'Angel wing photo backdrop',
  'Photo tribute space',
  'Keepsake token',
  'Comfort items',
];

// Mobile vet contacts
export const VET_CONTACTS = [
  { name: 'Sunset Pets (Dr Ben)', phone: '0437 209 880', notes: 'Transfers your pet directly to us after the euthanasia appointment.' },
  { name: 'Vet 2 Your Pet', phone: '1300 287 738', notes: 'Transfers to their Kirwan clinic. Pure Souls collects from the clinic at no charge — or can pick up directly from the client\'s home if they prefer.' },
  { name: 'NQ Mobile Vet (Dr Taylah)', phone: '0459 090 783', notes: 'Can transfer small pets. For medium and large pets, Pure Souls collects from the home within 30 minutes to 1 hour of the scheduled vet appointment.' },
];

// Payment methods (in order of preference)
export const PAYMENT_METHODS = [
  { method: 'Card over the phone', note: '1.4% surcharge; advise the client right before pressing payment on the card machine' },
  { method: 'Online booking', note: 'a good option for clients who want keepsakes or an urn but are unsure of what\'s on offer, or who want to pay with AfterPay' },
  { method: 'Invoice / bank transfer', note: 'we email the invoice; useful if the client doesn\'t have their card handy' },
  { method: 'Cash', note: 'received in person at our office, ideally the same or next day of the booking' },
  { method: 'VetPay', note: 'phone booking; collect the client\'s date of birth and 6-digit PIN' },
  { method: 'AfterPay', note: 'via online booking, or we can email a payment link if the client prefers to book over the phone' },
  { method: 'ZipPay / PayPal', note: 'available through online booking only' },
];

// Ashes return options
export const ASHES_RETURN = [
  { service: 'Ashes delivered to home (within 30 km)', fee: '$40' },
  { service: 'Ashes delivery to vet clinic', fee: 'Included' },
  { service: 'Customer collects from office (by appointment)', fee: 'Included' },
];

// FAQs
export const FAQS = [
  { q: 'My pet passed at home — what should I do?', a: 'Place your pet indoors on a sheet or towel in a cool, shaded area, with their limbs gently folded close to their body. A team member will arrive at your home as soon as practicable to help make this difficult transition as smooth as possible.' },
  { q: 'Can I visit your showroom to view your urn range and keepsakes?', a: 'Absolutely. Our showroom is open by appointment, during business hours.' },
  { q: 'Can I drive my pet to your facility?', a: 'Yes — you\'re welcome to bring your pet to our office in Garbutt by appointment. Please call ahead or book online so our team is available to assist you.' },
  { q: 'How long does the process take?', a: 'Typical turnaround is 5 days in our care. The aquacremation itself takes 18 hours — a long, gentle process.' },
  { q: 'What do you return to families?', a: 'Aquacremation gently preserves your pet\'s bones. We then dry them and turn them into a soft white powder — that\'s what you receive. The powder is pure calcium phosphate, the inorganic mineral that makes our bones strong.' },
  { q: 'What happens to the water after aquacremation?', a: 'The effluent is stored in a tank and collected by an external contractor, who treats and recycles it into non-potable water for sprinklers and industrial use. Pure Souls also uses non-potable water for all our aquacremations.' },
  { q: 'Is my pet cremated alone?', a: 'Yes — Pure Souls only offers individual aquacremation. Each pet has its own compartment, with tiny perforations top and bottom so water can circulate gently. Only the water is shared with other pets.' },
  { q: 'Where are the trees planted?', a: 'Your Pet Tree Planting Tribute is part of a reforestation project in either Western Australia or New South Wales, depending on your choice.' },
  { q: 'How is the microchip retrieved?', a: 'The microchip is retrieved as part of our careful handling procedures. A magnet is placed inside the pet\'s compartment, around the neck — it attracts the microchip and allows us to recover it during the process. The microchip remains fully functional after aquacremation and can still be scanned to show your pet\'s permanent ID. Recovery: $25. The microchip can be returned in a mini envelope, or set inside one of our beautiful resin teardrops — $70 including recovery.' },
];

// Booking questions per scenario
export const BOOKING_Q = {
  home_collection: [
    'Client details — name, mobile, email, home address',
    'Pet details — gender, breed, age, weight',
    'What time did the pet pass, or how long ago?',
    'Is the pet accessible on the ground floor? (any stairs or access constraints?)',
    'Are there any keepsakes or a personalised urn you\'d like to add to your booking?',
    'When your pet is ready to return home, do you prefer to pick him/her up from our office, or a home delivery for a small fee of $40?',
    'Where did you hear about us?',
    'Would you like to pay over the phone by card, or prefer that we bring a card machine to collection?',
  ],
  self_delivery: [
    'Client details — name, mobile, email, home address',
    'Pet details — gender, breed, age, weight',
    'What time did the pet pass, or how long ago?',
    'What time is suitable for you to bring your pet to our office?',
    'Where did you hear about us?',
    'Are there any keepsakes or a personalised urn you\'d like to add to your booking? Our keepsakes and urns are on display in our showroom — you are welcome to choose your preferences when you arrive.',
    'When your pet is ready to return home, do you prefer to pick him/her up from our office, or a home delivery for a small fee of $40?',
    'Would you like to pay over the phone by card, or prefer to pay in our office once you drop off your pet?',
  ],
  home_euth_vet_transfer: [
    'Client details — name, mobile, email, home address',
    'Pet details — gender, breed, age, weight',
    'Which mobile vet is attending the home?',
    'Date and time of the euthanasia',
    'Would you like to add any keepsakes or a personalised urn to your booking?',
    'When your pet is ready to return home, do you prefer to pick him/her up from our office, have your pet transferred back to the vet clinic, or a home delivery for a small fee of $40?',
    'Where did you hear about us?',
    'Would you like to pay over the phone by card, or have another preferred method of payment?',
  ],
  home_euth_ps_collection: [
    'Client details — name, mobile, email, home address',
    'Pet details — gender, breed, age, weight',
    'Which mobile vet is attending the home?',
    'Date and time of the euthanasia',
    'Preferred home collection time',
    'Would you like to add any keepsakes or a personalised urn to your booking?',
    'When your pet is ready to return home, do you prefer to pick him/her up from our office, or a home delivery for a small fee of $40?',
    'Where did you hear about us?',
    'Would you like to pay over the phone by card, or prefer that we bring a card machine to collection?',
  ],
  vet_euthanasia: [
    'Client details — name, mobile, email, home address',
    'Pet details — gender, breed, age, weight',
    'Vet clinic name and suburb',
    'Date and time of the euthanasia appointment',
    'When your pet is ready to come home, do you prefer to pick him/her up from our office, have your pet transferred back to the vet clinic, or a home delivery for a small fee of $40?',
    'Where did you hear about us?',
    'Would you like to pay over the phone by card, or have another preferred method of payment?',
  ],
  angel_area: [
    'Client details — name, mobile, email, home address',
    'Pet details — gender, breed, age, weight',
    'Preferred date and time (tentative until vet availability is confirmed)',
    'How many people attending? (maximum 4 including kids and pets)',
    'Pets attending? (well-behaved pets welcome on a leash)',
    'Bring their pet\'s bed, blanket, or favourite toys',
    'Would you like to add any keepsakes or a personalised urn to your booking?',
    'Where did you hear about us?',
    'Would you like to pay over the phone by card, or have another preferred method of payment?',
  ],
};

// Journey steps
export const JOURNEYS = {
  home_collection: [
    'Our team will attend your home within the next <strong>1 to 2 hours</strong>',
    'Once the team is on their way, you will receive an <strong>SMS with their ETA</strong> so you know when to expect them',
    'When your pet is safely in our care, we will <strong>update you again by SMS</strong>',
    'We will continue keeping you informed with <strong>SMS updates throughout the journey</strong> — the messages are informative, there is no need to respond to them',
    'You will also receive an <strong>email about the tree planting tribute</strong>, with information on the reforestation projects available so you can choose your preference if you have one',
    'The journey typically takes <strong>5 days</strong>',
    'Once your pet is ready to come home, we will contact you to organise a date and time for you and your pet to be <strong>reunited</strong>',
  ],
  self_delivery: [
    'You bring your pet to our <strong>Garbutt office</strong> at the booked date and time',
    'Our team will welcome you on arrival',
    'Once your pet is safely in our care, we will <strong>update you by SMS</strong>',
    'We will continue keeping you informed with <strong>SMS updates throughout the journey</strong> — the messages are informative, there is no need to respond to them',
    'You will also receive an <strong>email about the tree planting tribute</strong>, with information on the reforestation projects available so you can choose your preference if you have one',
    'The journey typically takes <strong>5 days</strong>',
    'Once your pet is ready to come home, we will contact you to organise a date and time for you and your pet to be <strong>reunited</strong>',
  ],
  vet_transfer: [
    'The mobile vet attends your home at the scheduled time',
    'After the euthanasia, the mobile vet <strong>transfers your pet directly to us</strong> — usually the <strong>same day</strong>, or the <strong>next day</strong> for late appointments',
    'Once your pet is safely in our care, we will <strong>update you by SMS</strong>',
    'We will continue keeping you informed with <strong>SMS updates throughout the journey</strong>',
    'You will also receive an <strong>email about the tree planting tribute</strong>',
    'The journey typically takes <strong>5 days</strong>',
    'Once your pet is ready to come home, we will contact you to organise a date and time for you and your pet to be <strong>reunited</strong>',
  ],
  ps_collection: [
    'The mobile vet attends your home at the scheduled time',
    'After the euthanasia, <strong>our team will arrive at your home</strong> to collect your pet — within <strong>30 minutes to 1 hour</strong> of the scheduled vet appointment',
    'Once your pet is safely in our care, we will <strong>update you by SMS</strong>',
    'We will continue keeping you informed with <strong>SMS updates throughout the journey</strong>',
    'You will also receive an <strong>email about the tree planting tribute</strong>',
    'The journey typically takes <strong>5 days</strong>',
    'Once your pet is ready to come home, we will contact you to organise a date and time for you and your pet to be <strong>reunited</strong>',
  ],
  vet_euthanasia: [
    'The euthanasia takes place at your vet clinic at the scheduled time — it helps to let the clinic know that Pure Souls will be taking care of your pet\'s aftercare',
    'Our team collects your pet from the clinic — usually the <strong>same day</strong> in Townsville (booking before 2 pm), or within <strong>a day or two</strong> for regional clinics',
    'Once your pet is safely in our care, we will <strong>update you by SMS</strong>',
    'We will continue keeping you informed with <strong>SMS updates throughout the journey</strong>',
    'You will also receive an <strong>email about the tree planting tribute</strong>',
    'The journey typically takes <strong>5 days</strong>',
    'Once your pet is ready to come home, we will contact you to organise a date and time for you and your pet to be <strong>reunited</strong>',
  ],
  angel_area: [
    'You and your family arrive at the Pure Souls office at the scheduled time',
    'Our team will welcome you and guide you to <strong>The Angel Area</strong>',
    'A licensed veterinarian performs the euthanasia with <strong>gentle sedation followed by the final injection</strong>',
    'You have <strong>up to 1 hour</strong> in The Angel Area to spend with your pet',
    'When you are ready, our team will take care of everything from here',
    'Once your pet is safely in our care, we will <strong>update you by SMS</strong>',
    'We will continue keeping you informed with <strong>SMS updates throughout the journey</strong>',
    'You will also receive an <strong>email about the tree planting tribute</strong>',
    'The journey typically takes <strong>5 days</strong>',
    'Once your pet is ready to come home, we will contact you to organise a date and time for you and your pet to be <strong>reunited</strong>',
  ],
};

// Helper: get combined price (aquacremation + fee)
export function getQuickQuote(petType, weightIdx, feeType) {
  const pricing = AQUA_PRICING[petType];
  if (!pricing || !pricing[weightIdx]) return null;
  const base = pricing[weightIdx].price;
  if (feeType === 'aqua_only') return base;
  if (feeType === 'bh') return base + COLLECTION_FEE_BH;
  if (feeType === 'ah') return base + COLLECTION_FEE_AH;
  if (feeType.startsWith('regional_')) {
    const town = feeType.replace('regional_', '');
    const rt = REGIONAL_TRANSPORT.find(r => r.town.toLowerCase() === town.toLowerCase());
    return rt ? base + rt.fee : base;
  }
  return base;
}
